import React, { useState } from 'react'
import { Box, Container, Grid, Typography, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import led1 from '../assets/images/led2.jpg'
import led2 from '../assets/images/led1.jpg'
import led3 from '../assets/images/led3.jpg'
import led4 from '../assets/images/led4.jpg'
import led5 from '../assets/images/led5.jpg'
import led6 from '../assets/images/led6.jpg'
import { Link } from 'react-router-dom';
import led_home from '../assets/images/ledm2.jpg'
import led7 from '../assets/images/led7.jpg'
import led8 from '../assets/images/led8.jpg'
import led9 from '../assets/images/led9.jpg'
import led10 from '../assets/images/LED.jpg'
import led11 from '../assets/images/led11.jpg'
const StyledTitle = styled(Typography)(({ theme }) => ({
  color: '#FF0000',
  marginBottom: theme.spacing(1),
}))

const StyledSubtitle = styled(Typography)(({ theme }) => ({
  color: '#000',
  marginBottom: theme.spacing(3),
}))

const CarouselContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  minHeight: 600,
  overflow: 'hidden', // Add this to prevent image overflow during transition
  [theme.breakpoints.down('md')]: {
    minHeight: 300,
  },
}))

const CarouselImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute', // Add absolute positioning
  top: 0,
  left: 0,
  transition: 'opacity 0.3s ease-in-out', // Add smooth transition
  opacity: 0, // Hide by default
  '&.active': {
    opacity: 1, // Show when active
  },
})

const CarouselButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  },
}))

const CarouselDots = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(2),
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: theme.spacing(1),
}))

const CarouselDot = styled(Box)(({ theme }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: 'rgba(255, 255, 255, 1)',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease-in-out', // Add smooth transition for dots
  '&.active': {
    backgroundColor: 'rgba(244, 152, 13, 0.93)',
  },
}))

export default function ConsultingPage() {
  const [activeSlide, setActiveSlide] = useState(0)

  const images = [
   led_home, led1,led2,led3,led4,led5,led6,led8
  ]

  const handlePrevious = () => {
    setActiveSlide((prev) => (prev === 0 ? images.length - 1 : prev - 1))
  }

  const handleNext = () => {
    setActiveSlide((prev) => (prev === images.length - 1 ? 0 : prev + 1))
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <br/>
      <Grid container spacing={4}>
        <Grid item xs={12} md={5}>
          <StyledSubtitle variant="h3" component="h2">
          LED TV MANUFACTURING
          </StyledSubtitle>
          <Typography variant="body1" sx={{ mb: 3 }}>
          Our LED TV manufacturing process combines precision engineering, cutting-edge technology, and rigorous quality control to deliver high-performance televisions that exceed customer expectations.


          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
          Our team of engineers and technicians works tirelessly to bring innovation and reliability to every LED TV we produce. From design to delivery, quality is at the heart of our process.
          </Typography>
        </Grid>
        <Grid item xs={12} md={7}>
          <CarouselContainer>
            {images.map((image, index) => (
              <CarouselImage
                key={index}
                src={image}
                alt={`Slide ${index + 1}`}
                className={index === activeSlide ? 'active' : ''}
              />
            ))}
            <CarouselButton
              onClick={handlePrevious}
              sx={{ left: 16 }}
              aria-label="Previous slide"
            >
              <ChevronLeftIcon />
            </CarouselButton>
            <CarouselButton
              onClick={handleNext}
              sx={{ right: 16 }}
              aria-label="Next slide"
            >
              <ChevronRightIcon />
            </CarouselButton>
            <CarouselDots>
              {images.map((_, index) => (
                <CarouselDot
                  key={index}
                  className={index === activeSlide ? 'active' : ''}
                  onClick={() => setActiveSlide(index)}
                />
              ))}
            </CarouselDots>
          </CarouselContainer>
        </Grid>
      </Grid>
    </Container>
  )
}
